export default {
	'Abnormal problem, please contact the website administrator!': '异常问题，请联系网站管理员！',
	'Automatic cancellation due to duplicate request:': '因为请求重复被自动取消：',
	'Error requesting address:': '请求地址出错:',
	'Gateway error!': '网关错误！',
	'HTTP version is not supported!': 'HTTP版本不受支持！',
	'Incorrect parameter!': '参数不正确！',
	'Interface redirected!': '接口重定向了！',
	'Network request timeout!': '网络请求超时！',
	'Operation successful': '操作成功',
	'Request timed out!': '请求超时！',
	'Server exception!': '服务端异常！',
	'Service not implemented!': '服务未实现！',
	'Service unavailable!': '服务不可用！',
	'The same data already exists in the system!': '系统已存在相同数据！',
	'The service is temporarily unavailable Please try again later!': '服务暂时无法访问，请稍后再试！',
	'You are disconnected!': '您断网了！',
	'You do not have permission to operate!': '您没有权限操作！',
	'登录信息已失效，请重新登录': 'ログイン情報が無効です。再度ログインしてください。',
	'服务器内部错误！': '服务器内部错误！',
	确定: 'OK',
	系统提示: 'システム通知',
}
